import { CategoryDocument } from "./firestore/categories";

export function getCategoryFilterMode(category?: CategoryDocument | null) {
  const isDigitalCameras =
    category?.id === "digital-cameras" ||
    category?.parents?.includes("digital-cameras");

  const isPhotoVideoLenses =
    category?.id === "photo-video-lenses" ||
    category?.parents?.includes("photo-video-lenses");

  const showUseCase = !category || isDigitalCameras;
  const showFindADeal = !showUseCase || isPhotoVideoLenses;

  return { showUseCase, showFindADeal };
}
